import React, { useEffect } from 'react';
import { MainScreenWrapper } from '../../components/Wrappers/MainScreenWrapper';
import { Box } from '@mui/material';
import { QuizzButton } from '../../components/Quizz/QuizzButton';
import theme, { TMaterialStyles } from '../../theme';
import { Illustration } from '../../components/Illustration';
import { useRootStore } from '../../stores';
import TypographyWithShadow from '../../components/Typography/TypographyWithShadow';
import { Icon } from '../../components/Icon';
import { formatNumberWithShortSymbol } from '../../helpers';
import { getUserStats } from '../../queries';
import { useTranslation } from 'react-i18next';

const MainScreen: React.FC = () => {
  const { userStats } = useRootStore();
  const { t } = useTranslation();

  useEffect(() => {
    getUserStats();
  }, []);

  return (
    <MainScreenWrapper>
      <Box sx={materialStyles.mainBackgroundContainer}>
        <Illustration
          illustrationName="MainBackground"
          sx={materialStyles.mainBackground}
        />
      </Box>
      <Box sx={materialStyles.screen}>
        <Box sx={materialStyles.userPointsContainer}>
          <Box sx={materialStyles.userPointWhiteContainer}>
            <Icon iconName="BlueScoreIcon" sx={materialStyles.scoreIcon} />
            <TypographyWithShadow
              shadowType="DARK"
              sx={materialStyles.userPointBlueText}
            >
              {formatNumberWithShortSymbol(userStats?.general_points)}
            </TypographyWithShadow>
            <Box sx={materialStyles.userPointModeContainer}>
              <TypographyWithShadow
                sx={materialStyles.userPointModeText}
                shadowType="MORE_DARK"
              >
                {t('common.general')}
              </TypographyWithShadow>
            </Box>
          </Box>
          <Box sx={materialStyles.userPointGoldContainer}>
            <Icon iconName="BlueScoreIcon" sx={materialStyles.scoreIcon} />
            <TypographyWithShadow
              shadowType="DARK"
              sx={materialStyles.userPointWhiteText}
            >
              {formatNumberWithShortSymbol(userStats?.competition_points)}
            </TypographyWithShadow>
            <Box sx={materialStyles.userPointModeContainer}>
              <TypographyWithShadow
                sx={materialStyles.userPointModeText}
                shadowType="MORE_DARK"
              >
                {t('common.competition')}
              </TypographyWithShadow>
            </Box>
          </Box>
        </Box>
        <QuizzButton />
        <Illustration
          sx={materialStyles.mainIllustration}
          illustrationName="HippoMain"
        />
      </Box>
    </MainScreenWrapper>
  );
};

const materialStyles: TMaterialStyles = {
  screen: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
    pb: '95px',
    position: 'relative',
    maxWidth: '574px',
    margin: 'auto',
    width: '100%',
  },
  userPointsContainer: {
    top: '24px',
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    zIndex: 2,
    alignItems: 'center',
    justifyContent: 'center',
    gap: '30px',
    flexWrap: 'wrap',
    paddingLeft: '30px',
    paddingRight: '15px',
  },
  userPointWhiteContainer: {
    py: '3px',
    backgroundColor: 'white',
    borderRadius: '14px',
    border: `2px solid ${theme.palette.secondary.main}`,
    px: '10px',
    minWidth: '150px',
    boxShadow: `0px 4px 0px ${theme.palette.primary.dark}`,
    position: 'relative',
    flex: 1,
  },
  userPointGoldContainer: {
    py: '3px',
    background: theme.palette.utils.gradients.gold,
    borderRadius: '14px',
    border: `2px solid ${theme.palette.secondary.main}`,
    px: '10px',
    minWidth: '150px',
    boxShadow: `0px 4px 0px ${theme.palette.primary.dark}`,
    position: 'relative',
    flex: 1,
  },
  userPointBlueText: {
    color: theme.palette.primary.main,
    fontFamily: 'Rubber Duck !important',
    fontSize: '31px',
    lineHeight: '100%',
    WebkitTextStroke: `1px ${theme.palette.grey[700]}`,
    'text-stroke': `1px ${theme.palette.grey[700]}`,
    textAlign: 'center',
    ml: '20px',
  },
  userPointWhiteText: {
    color: 'white',
    fontFamily: 'Rubber Duck !important',
    fontSize: '31px',
    lineHeight: '100%',
    WebkitTextStroke: `1px ${theme.palette.grey[700]}`,
    'text-stroke': `1px ${theme.palette.grey[700]}`,
    textAlign: 'center',
    ml: '20px',
  },
  scoreIcon: {
    width: '47px',
    height: '47px',
    position: 'absolute',
    top: '-4px',
    left: '-15px',
  },
  userPointModeContainer: {
    py: '4px',
    px: '13px',
    borderRadius: '14px',
    backgroundColor: theme.palette.secondary.main,
    position: 'absolute',
    left: '55%',
    transform: 'translate(-50%, 0)',
  },
  userPointModeText: {
    fontFamily: 'Rubber Duck !important',
    color: 'white',
    fontSize: '15px',
    lineHeight: '100%',
  },
  mainBackgroundContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 0,
  },
  mainBackground: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 1,
  },
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  mainIllustration: {
    width: '100%',
    maxWidth: '361px',
    paddingTop: '200px',
    paddingLeft: '16px',
    paddingRight: '16px',
    mt: '48px',
    position: 'absolute',
    bottom: '160px',
    left: ' 50%',
    transform: 'translate(-50%, 0)',
    zIndex: 1,
  },
};

export default MainScreen;
